// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"84806f0b","530":"109965ca","843":"3d0a871a"}[chunkId] + ".chunk.js";
};